var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagEditDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.25C10.3683 20.25 8.77325 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75357 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32016 6.16637 6.16637C7.32016 5.01259 8.79016 4.22685 10.3905 3.90853C11.9908 3.5902 13.6496 3.75357 15.1571 4.378C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.25 14.188 19.3808 16.2865 17.8336 17.8336C16.2865 19.3808 14.188 20.25 12 20.25ZM12 5.25C10.665 5.25 9.35993 5.64588 8.2499 6.38758C7.13987 7.12928 6.27471 8.18349 5.76382 9.41689C5.25293 10.6503 5.11925 12.0075 5.3797 13.3169C5.64015 14.6262 6.28303 15.829 7.22703 16.773C8.17104 17.717 9.37377 18.3599 10.6831 18.6203C11.9925 18.8808 13.3497 18.7471 14.5831 18.2362C15.8165 17.7253 16.8707 16.8601 17.6124 15.7501C18.3541 14.6401 18.75 13.335 18.75 12C18.75 10.2098 18.0388 8.4929 16.773 7.22703C15.5071 5.96116 13.7902 5.25 12 5.25Z",
    fill: "#A3A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.182 14.1209L13.0607 11.9996L15.182 9.87827L14.1213 8.81761L12 10.9389L9.87868 8.81761L8.81802 9.87827L10.9393 11.9996L8.81802 14.1209L9.87868 15.1816L12 13.0603L14.1213 15.1816L15.182 14.1209Z",
    fill: "#A3A1AA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagEditDelete);
export default __webpack_public_path__ + "static/media/tagEditDelete.b9d6fd1b.svg";
export { ForwardRef as ReactComponent };